// Tracks recently viewed floors per browser (no backend required).
// Stores a small list in localStorage and exposes a hook that re-reads
// when other tabs (or other components in the same tab) update it.

const STORAGE_KEY = 'arrow.recents.floors.v1'
const MAX_ENTRIES = 8
const EVENT_NAME = 'arrow:recents-changed'

function readRaw() {
  if (typeof window === 'undefined') return []
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY)
    if (!raw) return []
    const parsed = JSON.parse(raw)
    return Array.isArray(parsed) ? parsed : []
  } catch {
    return []
  }
}

function writeRaw(list) {
  if (typeof window === 'undefined') return
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(list))
    window.dispatchEvent(new CustomEvent(EVENT_NAME))
  } catch {
    // ignore quota / privacy errors
  }
}

export function recordRecentFloor(floor) {
  if (!floor?.id) return
  const entry = {
    id: floor.id,
    name: floor.name,
    building: floor.building?.name || floor.building_name || null,
    site: floor.site?.name || floor.site_name || null,
    organization: floor.organization?.name || floor.organization_name || null,
    counts: floor.counts || null,
    publish_status: floor.publish_status || null,
    visited_at: new Date().toISOString(),
  }
  const list = readRaw().filter((r) => r.id !== entry.id)
  list.unshift(entry)
  writeRaw(list.slice(0, MAX_ENTRIES))
}

export function getRecentFloors() {
  return readRaw()
}

export function clearRecentFloors() {
  writeRaw([])
}

import { useEffect, useState } from 'react'

export function useRecentFloors() {
  const [list, setList] = useState(readRaw)

  useEffect(() => {
    const refresh = () => setList(readRaw())
    window.addEventListener(EVENT_NAME, refresh)
    window.addEventListener('storage', refresh)
    return () => {
      window.removeEventListener(EVENT_NAME, refresh)
      window.removeEventListener('storage', refresh)
    }
  }, [])

  return list
}
